/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { Link } from 'react-router-dom';

const routesToMenuItems = ({
  routes: _routes,
  level0 = true,
  collapsedSidebar = false,
  forPermission,
  getClassName = () => null,
  hide = () => false,
}) => _routes?.map((route) => {
  const icon = route.icon ? <route.icon /> : <span />;
  if (route.children) {
    const children = [];
    if (collapsedSidebar && level0 && !forPermission) {
      children.push({
        label: route.title,
        key: route.path,
        icon,
        className: 'ant-menu-item-active ant-menu-item-active-fixed',
      });
    }
    children.push(...routesToMenuItems({
      routes: route.children,
      collapsedSidebar,
      forPermission,
      level0: false,
      getClassName,
      hide,
    }).filter((e) => e));
    return {
      label: route.title,
      key: route.path,
      icon,
      children,
      className: getClassName(null, children),
      hidden: hide(null, children),
    };
  }
  if (route.showInSidebar) {
    return {
      label: forPermission ? route.title : (<Link to={route.path}>{route.title}</Link>),
      key: route.path,
      icon,
      title: route.title,
      permissionconfig: route.permissionConfig,
      className: getClassName(route),
      hidden: hide(route, null),
    };
  }
  return null;
});

export default routesToMenuItems;
